import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import ListLinkBox from '../../../../../components/UI/ListLinkBox';
import { translate, gerarCSV } from '../../../../../utils/util';
import { ENUMS } from '../../../../../utils/constants';
import PickingService from '../../../../../services/PickingService';

const DeliveryFilter = (props) => {
    const subtitlesDeliveryFilter = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('general.filter', 'delivery') }];
    }

    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: 'filter/partnumber', icon: 'layers', text: translate('general.design', 'delivery') }];
        menuItems = [...menuItems, { route: 'filter/cim', icon: 'layers', text: "CIM" }];
        menuItems = [...menuItems, { route: 'filter/order', icon: 'layers', text: "Pedido" }];

        if (navigator.userAgent !== 'logisticspwa') {
            menuItems = [...menuItems, {
                icon: 'mdi mdi-clipboard-list-outline',
                text: translate("delivery:open-calls"),
                route: 'filter',
                onClick: () => {
                    props.getOrdesOpen(ENUMS.eOrderType.LoweringDelivery.value, (response) => {
                        gerarCSV(translate("delivery:calls"), response);
                        props.history.go(-1);
                    });
                }
            }];

            menuItems = [...menuItems, {
                icon: 'mdi mdi-clipboard-list-outline',
                text: translate("delivery:open-tasks"),
                route: 'filter',
                onClick: () => {
                    props.getOrdesItemOpen(ENUMS.eOrderType.LoweringDelivery.value, (response) => {
                        gerarCSV(translate("delivery:tasks"), response);
                        props.history.go(-1);
                    });
                }
            }];
        }

        menuItems = [...menuItems, {
            icon: 'mdi mdi-clipboard-list-outline',
            text: translate("delivery:report"),
            route: {
                pathname: 'report',
                state: {
                    orderType: ENUMS.eOrderType.LoweringDelivery.value
                }
            }
        }];

        return menuItems;
    }

    return (
        <div>
            <Breadcrumbs id="deliveryFilter" title={{ icon: "mdi mdi-cart-check", label: translate('title', 'delivery') }} subtitles={subtitlesDeliveryFilter()} />
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox options={menu()} />
            </div>
        </div>
    );
}

export const mapStateToProps = () => {
    return {
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getOrdesOpen: (orderType, callback) => {
            dispatch(PickingService.getOrdersOpen(orderType, callback));
        },
        getOrdesItemOpen: (orderType, callback) => {
            dispatch(PickingService.getOrdersItemOpen(orderType, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryFilter)));

